import React, { createContext, useState, useContext, useEffect } from 'react';

import IOrder from '~/interfaces/IOrder';

interface BackordersContextData {
  orders: {
    client: any;
    products: any;
  }[];
  saveOrder(order: any): void;
  recoverOrder: (index: number) => any;
}

const BackordersContext = createContext<BackordersContextData>(
  {} as BackordersContextData,
);

export const BackordersProvider: React.FC = ({ children }) => {
  const [orders, setOrders] = useState<any[]>([]);

  function saveOrder(order: any) {
    const items = [...orders, order];

    setOrders(items);

    localStorage.setItem('@tempedido:backorders', JSON.stringify(items));
  }

  function recoverOrder(index: number) {
    const items = [...orders];

    const [order] = items.splice(index, 1);

    setOrders(items);

    localStorage.setItem('@tempedido:backorders', JSON.stringify(items));

    return order;
  }

  useEffect(() => {
    const items = localStorage.getItem('@tempedido:backorders');

    if (items) {
      setOrders(JSON.parse(items));
    }
  }, []);

  return (
    <BackordersContext.Provider value={{ orders, saveOrder, recoverOrder }}>
      {children}
    </BackordersContext.Provider>
  );
};

export function useBackorders(): BackordersContextData {
  const context = useContext(BackordersContext);
  return context;
}
